import { useState } from "react";

// Simple seat grid: rows A-J, 12 cols. Premium = front 3 rows.
const ROWS = ["A","B","C","D","E","F","G","H","J","K"];
const COLS = 12;

export default function SeatGrid({ booked = [], onChange, max = 8 }) {
  const [selected, setSelected] = useState([]);

  const toggle = (id, premium) => {
    let next;
    if (selected.includes(id)) next = selected.filter((s) => s !== id);
    else if (selected.length >= max) return;
    else next = [...selected, id];
    setSelected(next);
    onChange?.(next);
  };

  return (
    <div className="space-y-3" data-testid="seat-grid">
      <div className="text-center text-xs uppercase tracking-[0.3em] text-muted-foreground">Screen</div>
      <div className="h-2 mx-auto w-2/3 rounded-full bg-gradient-to-r from-transparent via-primary to-transparent shadow-[0_0_60px_hsl(var(--primary))]" />
      <div className="space-y-1.5 mt-6">
        {ROWS.map((row, ri) => {
          const premium = ri < 3;
          return (
            <div key={row} className="flex items-center gap-1.5 justify-center">
              <span className="w-6 text-xs font-bold text-muted-foreground">{row}</span>
              {Array.from({ length: COLS }).map((_, i) => {
                const id = `${row}${i + 1}`;
                const isBooked = booked.includes(id) || (ri === 4 && i % 7 === 0);
                const isSel = selected.includes(id);
                return (
                  <button
                    key={id}
                    data-testid={`seat-${id}`}
                    disabled={isBooked}
                    onClick={() => toggle(id, premium)}
                    className={`h-7 w-7 rounded-md border text-[10px] font-bold transition-all ${
                      isBooked ? "bg-muted text-muted-foreground/40 border-transparent cursor-not-allowed line-through" :
                      isSel ? "bg-primary text-primary-foreground border-primary scale-110" :
                      premium ? "border-secondary/60 text-secondary hover:bg-secondary/10" :
                      "border-border hover:border-primary hover:bg-primary/10"
                    }`}
                    aria-label={`Seat ${id}${premium ? " premium" : ""}`}
                  >
                    {i + 1}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-center gap-5 pt-4 text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5"><span className="h-3 w-3 rounded-sm border border-border" /> Standard</span>
        <span className="flex items-center gap-1.5"><span className="h-3 w-3 rounded-sm border border-secondary" /> Premium</span>
        <span className="flex items-center gap-1.5"><span className="h-3 w-3 rounded-sm bg-primary" /> Selected</span>
        <span className="flex items-center gap-1.5"><span className="h-3 w-3 rounded-sm bg-muted" /> Sold</span>
      </div>
    </div>
  );
}
